import React, { useRef, useState } from 'react';
import { isOddUnderMinValue, useOddData } from '../../common/OddWrapper';
import { useHighlightOddChange } from '../../common/useHighlightOddChange';
import { getToolTipDesc, hideTooltip, showTooltip } from '../../data/utils';

export default function InnerOdd(props) {
    const [tooltip, setTooltip] = useState(null);
    const oddContainer = useRef(null);
    
    useHighlightOddChange(oddContainer, props.value, props.matchData.isLive);

    const [desc, selected, addBet] = useOddData(props);
    
    function handleMouseOver() {
        if (oddContainer.current) {
            const t = tooltip ? tooltip : getToolTipDesc(props);
            showTooltip(oddContainer.current, t);
            if (tooltip == null) {
                setTooltip(t);
            }
        }
    }
    function handleOnMouseOut() {
        hideTooltip();
    }

    let classes = '';
    if (selected) {
        classes += 'selezionata';
    }
    if (props.betData.pClass != null) {
        classes += ' ' + props.betData.pClass;
    }

    return (
        <>
            {props.value == null || isOddUnderMinValue(props.rawValue) ?
                <div className="odd-container quota bg-grigio-chiaro bordo-tondo padding-orizzontale">
                    <span className="banner-odd-desc text-uppercase">{desc}</span>
                    <span><i className="fa fa-lock"></i></span>
                </div>
                :
                <div className={"odd-container quota bg-grigio-chiaro bordo-tondo padding-orizzontale " + classes} ref={oddContainer} onMouseOver={handleMouseOver} onMouseOut={handleOnMouseOut} onClick={addBet}>
                    <span className="banner-odd-desc text-uppercase">{desc}</span>
                    <span>{props.value}</span>
                </div>
            }
        </>
    );
}
